import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
//import Tooltip from "@material-ui/core/Tooltip";

import {
  addTab,
  removeOldestDynamicTab,
} from "../../actions/siteEntranceExit/tabs";
import { removeTabFromHistory } from "../../actions/siteEntranceExit/tabHistory";

import images from "../../assets/img/images";

const styles = {
  button: {
    margin: "0px 10px",
    width: "30px",
    minWidth: "0px",
  },
};

const TabHistory = (props) => {
  const { classes } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const tabHistory = props.siteEntranceExit[props.section].tabHistory;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (tab, index) => {
    handleClose();
    let remainingSpace =
      window.innerWidth -
      200 * props.siteEntranceExit[props.section].tabs.length;
    // Not enough space, delete the oldest dynamic tab
    if (remainingSpace < 220) {
      props.dispatch(removeOldestDynamicTab(props.section));
    }
    props.dispatch(addTab(props.section, null, tab));
    props.dispatch(removeTabFromHistory(props.section, index));
  };

  return (
    <Box>
      <Box>
        <Button
          onClick={handleClick}
          className={classes.button}
          disabled={tabHistory.length === 0}
        >
          <img
            src={
              tabHistory.length === 0
                ? images.tabHistoryDisabled
                : images.tabHistoryColored
            }
            style={{
              minWidth: "20px",
            }}
            alt="history"
          />
        </Button>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        MenuListProps={{
          disablePadding: true,
        }}
      >
        {tabHistory.map((tab, index) => (
          <MenuItem
            key={tab.eventGroupId}
            onClick={() => handleClickItem(tab, index)}
            style={{ fontSize: "1em" }}
          >
            {`#${tab.eventGroupId} ${
              get(tab, ["zone", "name"]) || I18n.get("site_" + tab.status)
            }`}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(TabHistory));
